"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAttributesByVariantKey = void 0;
const getAttributesByVariantKey = (variantKey, productVariantOptions) => {
    let attributes = [];
    const sortedOptions = productVariantOptions.sort((a, b) => (a < b ? -1 : 1));
    const parsedVariants = variantKey.split('/');
    if (sortedOptions.length !== parsedVariants.length)
        return [];
    sortedOptions.forEach((attribute, index) => {
        attributes.push({ attribute, value: parsedVariants[index] });
    });
    return attributes;
};
exports.getAttributesByVariantKey = getAttributesByVariantKey;
//# sourceMappingURL=getAttributesByVariantKey.js.map